import { Component, Injector, ViewChild, OnDestroy } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { timer, Subscription } from 'rxjs';
import { AppAuthService } from '../auth/app-auth.service';

@Component({
    standalone: false,
    selector: 'session-timeout-modal',
    templateUrl: './session-timeout-modal.component.html'
})
export class SessionTimeoutModalComponent extends AppComponentBase implements OnDestroy {

    @ViewChild('modal', { static: true }) modal: ModalDirective;

    timeOutSecond = parseInt(this.s('App.UserManagement.SessionTimeOut.ShowTimeOutNotificationSecond'));
    currentSecond: number;
    progresbarWidth = '100%';
    private subscription: Subscription;

    constructor(
        injector: Injector,
        private _appAuthService: AppAuthService
    ) {
        super(injector);
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    start(): void {
        this.currentSecond = this.timeOutSecond;
        this.subscription = timer(0, 1000).subscribe(() => {
            this.changeNotifyContent();
        });
        this.modal.show();
    }

    stop(): void {
        this.currentSecond = this.timeOutSecond;
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.modal.hide();
    }

    private done(): void {
        this.stop();

        let isSessionLockScreenEnabled = abp.setting.getBoolean('App.UserManagement.SessionTimeOut.ShowLockScreenWhenTimedOut');
        if (isSessionLockScreenEnabled) {
            this.redirectToLockScreen();
        } else {
            const user = this.appSession.user;
            AppAuthService.markMicrosoftSsoResume(user && (user.emailAddress || user.userName));
            this._appAuthService.logout(true, undefined, true);
        }
    }

    private changeNotifyContent(): void {
        this.currentSecond--;
        if (this.currentSecond <= 0) {
            this.progresbarWidth = '0%';
            this.done();
        } else {
            this.progresbarWidth = (this.currentSecond / this.timeOutSecond * 100) + '%';
        }
    }

    private redirectToLockScreen(): void {
        const user = this.appSession.user;
        const tenant = this.appSession.tenant;

        if (user) {
            abp.utils.setCookieValue('userInfo', JSON.stringify(
                {
                    userName: user.userName,
                    emailAddress: user.emailAddress,
                    profilePictureId: user.profilePictureId,
                    tenant: tenant ? tenant.tenancyName : 'Host'
                }), undefined, abp.appPath);
            AppAuthService.markMicrosoftSsoResume(user.emailAddress || user.userName);
            this._appAuthService.logout(true, '/account/session-locked', true);
        } else {
            this._appAuthService.logout(true);
        }
    }
}
